import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';
import Router from './routes/Rutas';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { esES } from '@mui/x-date-pickers/locales';
import { theme } from './tema/theme';
import { SnackbarUtilsConfigurator } from './utilidades/Snackbar';
import { AuthProvider } from './contexto';

dayjs.locale('es');

function App() {
  return (
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es" localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}>
        <ThemeProvider theme={theme}>
          <AuthProvider>
              <SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <SnackbarUtilsConfigurator />
                <Router></Router>
              </SnackbarProvider>
          </AuthProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </BrowserRouter >
  );
}

export default App;